

































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import SkriningPengunjungSvc from "@/services/SkriningPengunjungService";
import SkriningPengunjungTrenChart from "@/components/skrining-pengunjung/SkriningPengunjungTrenChart.vue";
import SkriningPengunjungBarChart from "@/components/skrining-pengunjung/SkriningPengunjungBarChart.vue";
import SkriningPengunjungHubunganChart from "@/components/skrining-pengunjung/SkriningPengunjungHubunganChart.vue";
import SkriningPengunjungDetailDialog from "@/components/skrining-pengunjung/SkriningPengunjungDetailDialog.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import {
  SkriningPengunjungLaporanFilter,
  SkriningPengunjungMeta,
  SkriningPengunjungOpsi,
  SkriningPengunjungRekap,
  SkriningPengunjungRekapMode,
  SkriningPengunjungRow
} from "@/types/skriningPengunjung";

const NAMA_BULAN = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember"
];

function filterAwal() {
  const kini = new Date();
  return {
    mode: "bulanan" as SkriningPengunjungRekapMode,
    tanggal: toDateString(kini) || "",
    bulan: String(kini.getMonth() + 1).padStart(2, "0"),
    tahun: String(kini.getFullYear()),
    tanggal_dari: "",
    tanggal_sampai: "",
    unit_id: null as string | null,
    q: ""
  };
}

@Component({
  components: {
    VCDateTimePicker,
    SkriningPengunjungTrenChart,
    SkriningPengunjungBarChart,
    SkriningPengunjungHubunganChart,
    SkriningPengunjungDetailDialog
  }
})
export default class SkriningPengunjungLaporanPage extends Vue {
  opsi: SkriningPengunjungOpsi = { bangsal: [], hubungan: [] };
  filter = filterAwal();
  hariIni = new Date();

  rekap: SkriningPengunjungRekap | null = null;
  memuatRekap = false;
  mengunduh = false;

  baris: SkriningPengunjungRow[] = [];
  metaData: SkriningPengunjungMeta | null = null;
  memuatData = false;
  opsiTabelData = { page: 1, itemsPerPage: 25 };
  private paramAktif: SkriningPengunjungLaporanFilter | null = null;
  private nomorRekap = 0;
  private nomorData = 0;

  dialogDetail = false;
  detailRow: SkriningPengunjungRow | null = null;

  opsiMode = [
    { text: "Tanggal", value: "harian" },
    { text: "Bulan", value: "bulanan" },
    { text: "Tahun", value: "tahunan" },
    { text: "Rentang tanggal", value: "rentang" }
  ];

  opsiBulan = NAMA_BULAN.map((nama, i) => ({
    text: nama,
    value: String(i + 1).padStart(2, "0")
  }));

  headerData = [
    { text: "Waktu", value: "waktu_kunjungan", sortable: false },
    { text: "Pengunjung", value: "nama_pengunjung", sortable: false },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Ruang / Kamar", value: "unit", sortable: false },
    { text: "Hubungan", value: "hubungan_label", sortable: false },
    { text: "Ikut", value: "jumlah_pengikut", sortable: false, align: "center" },
    { text: "TTD", value: "ada_ttd", sortable: false, align: "center" },
    { text: "Petugas", value: "petugas.nama", sortable: false },
    { text: "", value: "aksi", sortable: false, align: "end" }
  ];

  get opsiTahun(): string[] {
    const kini = new Date().getFullYear();
    const out: string[] = [];
    for (let i = 0; i <= 5; i++) out.push(String(kini - i));
    return out;
  }

  get tanggalPeriode(): Date | null {
    return composeDate(this.filter.tanggal, "00:00");
  }

  set tanggalPeriode(val: Date | null) {
    this.filter.tanggal = toDateString(val) || "";
  }

  get tanggalDari(): Date | null {
    return composeDate(this.filter.tanggal_dari, "00:00");
  }

  set tanggalDari(val: Date | null) {
    this.filter.tanggal_dari = toDateString(val) || "";
  }

  get tanggalSampai(): Date | null {
    return composeDate(this.filter.tanggal_sampai, "00:00");
  }

  set tanggalSampai(val: Date | null) {
    this.filter.tanggal_sampai = toDateString(val) || "";
  }

  get bolehMuatDetail(): boolean {
    return (userModule.user?.role?.id ?? 3) <= 2;
  }

  get kartuKpi() {
    const r = this.rekap ? this.rekap.ringkasan : null;
    return [
      {
        judul: "Total Kunjungan",
        nilai: r ? r.total_kunjungan : "-",
        keterangan: "Pengunjung yang didata"
      },
      {
        judul: "Total Orang",
        nilai: r ? r.total_orang : "-",
        keterangan: "Pengunjung + pengikut"
      },
      {
        judul: "Pasien Dikunjungi",
        nilai: r ? r.pasien_dikunjungi : "-",
        keterangan: "Pasien rawat inap berbeda"
      },
      {
        judul: "Rerata per Hari",
        nilai: r ? r.rerata_kunjungan_per_hari : "-",
        keterangan: this.rekap ? `${this.rekap.periode.jumlah_hari} hari dalam periode` : ""
      }
    ];
  }

  get grafik() {
    const r = this.rekap;
    return {
      tren: {
        labels: r ? r.tren.data.map(t => t.label) : [],
        kunjungan: r ? r.tren.data.map(t => t.kunjungan) : [],
        orang: r ? r.tren.data.map(t => t.orang) : []
      },
      bangsal: {
        labels: r ? r.per_bangsal.map(b => b.unit_nama) : [],
        data: r ? r.per_bangsal.map(b => b.kunjungan) : []
      },
      hubungan: {
        labels: r ? r.per_hubungan.map(h => h.label) : [],
        data: r ? r.per_hubungan.map(h => h.kunjungan) : []
      },
      jam: {
        labels: r ? r.per_jam.map(j => j.label.slice(0, 2)) : [],
        data: r ? r.per_jam.map(j => j.kunjungan) : []
      }
    };
  }

  async mounted() {
    this.terapkan();
    this.opsi = await SkriningPengunjungSvc.opsi().catch(() => this.opsi);
  }

  @Watch("opsiTabelData", { deep: true })
  onOpsiTabelData() {
    if (this.paramAktif) this.muatData();
  }

  paramPeriode(): SkriningPengunjungLaporanFilter {
    const f = this.filter;
    const params: SkriningPengunjungLaporanFilter = { mode: f.mode };

    if (f.mode === "harian") params.periode = f.tanggal;
    if (f.mode === "bulanan") params.periode = `${f.tahun}-${f.bulan}`;
    if (f.mode === "tahunan") params.periode = f.tahun;
    if (f.mode === "rentang") {
      params.tanggal_dari = f.tanggal_dari;
      params.tanggal_sampai = f.tanggal_sampai;
    }
    if (f.unit_id) params.unit_id = f.unit_id;
    if ((f.q || "").trim()) params.q = f.q.trim();

    return params;
  }

  terapkan() {
    if (this.filter.mode === "rentang" && (!this.filter.tanggal_dari || !this.filter.tanggal_sampai)) {
      appModule.sendErrorNotice("Isi tanggal awal dan tanggal akhir rentang terlebih dahulu.");
      return;
    }

    this.paramAktif = this.paramPeriode();
    this.muatRekap();

    if (this.opsiTabelData.page !== 1) {
      this.opsiTabelData = { ...this.opsiTabelData, page: 1 };
      return;
    }
    this.muatData();
  }

  reset() {
    this.filter = filterAwal();
    this.terapkan();
  }

  async muatRekap() {
    if (!this.paramAktif) return;

    const nomor = ++this.nomorRekap;
    this.memuatRekap = true;
    try {
      const hasil = await SkriningPengunjungSvc.rekap(this.paramAktif);
      if (nomor === this.nomorRekap) this.rekap = hasil;
    } catch {
      return;
    } finally {
      if (nomor === this.nomorRekap) this.memuatRekap = false;
    }
  }

  async muatData() {
    if (!this.paramAktif) return;

    const nomor = ++this.nomorData;
    this.memuatData = true;
    try {
      const hasil = await SkriningPengunjungSvc.dataLaporan({
        ...this.paramAktif,
        page: this.opsiTabelData.page,
        per_page: this.opsiTabelData.itemsPerPage
      });
      if (nomor !== this.nomorData) return;
      this.baris = hasil.data;
      this.metaData = hasil.meta;
    } catch {
      return;
    } finally {
      if (nomor === this.nomorData) this.memuatData = false;
    }
  }

  async unduhExcel() {
    if (!this.paramAktif) return;

    this.mengunduh = true;
    try {
      await SkriningPengunjungSvc.unduhExcel(this.paramAktif);
    } catch {
      return;
    } finally {
      this.mengunduh = false;
    }
  }

  lihat(row: SkriningPengunjungRow) {
    this.detailRow = row;
    this.dialogDetail = true;
  }

  formatWaktu(waktu: string): string {
    return waktu ? moment(waktu, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm") : "-";
  }
}
